module.exports = __webpack_public_path__ + "static/img/ACC.1ae326ee.png";